import { gql } from '@apollo/client';

export const GET_APPOINTMENTS_BY_COACH_QUERY = gql`
  query GetAppointmentsByCoach($coachId: String!, $from: DateTime!, $to: DateTime!) {
    getAppointmentsByCoachId(coachId: $coachId, from: $from, to: $to) {
      id
      clientId
      coachId
      startDate
      endDate
      title
      createdAt
      updatedAt
      isCanceled
      profilePic
      clientFirstName
      clientLastName
      clientEmail
      platform
      meetingURL
    }
  }
`;

export const GET_APPOINTMENTS_BY_CLIENT_QUERY = gql`
  query GetAppointmentsByClient($clientId: String!, $from: DateTime!, $to: DateTime!) {
    getAppointmentsByClientId(clientId: $clientId, from: $from, to: $to) {
      id
      clientId
      coachId
      startDate
      endDate
      title
      createdAt
      updatedAt
      isCanceled
      profilePic
      clientFirstName
      clientLastName
      clientEmail
      platform
      meetingURL
    }
  }
`;

export const GET_APPOINTMENT_BY_CLIENT_QUERY = gql`
  query GetAppointmentById($id: String!) {
    getAppointmentsByClientId(id: $id, take: 10) {
      id
      clientId
      coachId
      startDate
      endDate
      title
      createdAt
      updatedAt
      isCanceled
      profilePic
      clientFirstName
      clientLastName
      clientEmail
      platform
      meetingURL
    }
  }
`;

export const CREATE_APPOINTMENT_MUTATION = gql`
  mutation CreateAppointment($CreateAppointment: CreateAppointment!) {
    createAppointment(CreateAppointment: $CreateAppointment) {
      id
      clientId
      coachId
      startDate
      endDate
      title
      createdAt
      updatedAt
      isCanceled
      profilePic
      clientFirstName
      clientLastName
      clientEmail
      platform
      meetingURL
    }
  }
`;

export const DELETE_APPOINTMENT_MUTATION = gql`
  mutation DeleteAppointment($id: String!) {
    deleteAppointment(id: $id) {
      id
    }
  }
`;

export const UPDATE_APPOINTMENT_MUTATION = gql`
  mutation EditAppointment($UpdateAppointment: UpdateAppointment!) {
    updateAppointment(UpdateAppointment: $UpdateAppointment) {
      id
      clientId
      coachId
      startDate
      endDate
      title
      description
      createdAt
      updatedAt
      isCanceled
      profilePic
      clientFirstName
      clientLastName
      clientEmail
      platform
      meetingURL
    }
  }
`;
